import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EButtonLabel, deepCopy, makeid, removeUndefined } from 'na-lib';
import { CommentsService } from 'src/app/service/comments.service';
import { SettingsService } from 'src/app/service/settings.service';
import { OneclikpayItemDialogComponent } from '../oneclikpay-item-dialog/oneclikpay-item-dialog.component';

@Component({
    selector: 'app-oneclickpay-edit',
    templateUrl: './oneclickpay-edit.component.html',
    styleUrl: './oneclickpay-edit.component.css',
    standalone: false
})

export class OneclickpayEditComponent {
  oneClickPayEditForm!:FormGroup
  oneClickPayEditData:any
  widgetNumber:any
  oldData:any
  passId:string
  allItems: any = []
  userHasBetaWidgetRole = false
  buttonLabelOptions = Object.keys(EButtonLabel)
  styleClickPay="button"

  constructor(public dialogRef: MatDialogRef<OneclickpayEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private commentService: CommentsService,
    private fb: FormBuilder,
    private settingsService: SettingsService){
      dialogRef.disableClose=true
  }

  ngOnInit(): void{
    if(this.settingsService.checkIfBetaRoleAccess())
    this.userHasBetaWidgetRole = true

    this.oneClickPayEditData=deepCopy(this.data.values)
    this.oldData=deepCopy(this.data.values)
    this.widgetNumber= this.data.widget
    this.passId = this.data.passId

    this.oneClickPayEditForm = this.fb.group({
      items:[],
      style:[],
      type:[],
      buttonLabel:[],
      id:[],
      successText:[],
      filter:[],
      widgetStyle:[],
      name:[]
    })

    //this.oneClickPayEditForm.valueChanges.subscribe( value => console.log(value))

    const {id, type,filter, items, style,buttonLabel, successText,widgetStyle, name } = this.oneClickPayEditData

    this.oneClickPayEditForm.patchValue({
      items:items ? items : [],
      style:style ? style : "button",
      type: type ? type : undefined,
      buttonLabel: buttonLabel ? buttonLabel : undefined,
      id: id ? id : makeid(5),
      successText: successText ? successText : undefined,
      filter: filter ? filter : undefined,
      widgetStyle: widgetStyle ? widgetStyle : undefined,
      name: name ? name : undefined
    })

    this.oneClickPayEditForm.get('style')?.valueChanges.subscribe(value => this.styleClickPay = value)
    this.oneClickPayEditForm.get('items')?.valueChanges.subscribe(items => this.allItems = items)

    this.styleClickPay = style
    this.allItems = items ? items : []
  }

  returnChangesFilters($event){
    this.oneClickPayEditForm.patchValue({filter: $event.newFilters})
  }

  returnChangesStyle($event){
    this.oneClickPayEditForm.patchValue({widgetStyle: $event.newStyle})
  }

  addItem(){
    const newItem = {
      images: [],
      id:makeid(4),
      
      title: undefined,
      description: undefined,
      price: { amount: 0, currency: "euro", vat: undefined }
    }

    let dialogRef = this.dialog.open(OneclikpayItemDialogComponent, {
      width: '1000px',
      data:newItem
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        this.allItems.push(result[1])
        this.oneClickPayEditForm.patchValue({items:this.allItems})

      }      
    })
  }

  editItem(item, index){
    let dialogRef = this.dialog.open(OneclikpayItemDialogComponent, {
      width: '1000px',
      data:item
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        item = result[1]
        this.allItems[index] = item
        this.oneClickPayEditForm.patchValue({items:this.allItems})
      }      
    })
    
  }

  deleteItem(item, index){
    this.allItems.splice(index,1)
    this.oneClickPayEditForm.patchValue({items:this.allItems})
  }

  async saveChanges(){
    this.commentService.progressSpin.emit(true)
    const data = removeUndefined( this.oneClickPayEditForm.value)
    this.dialogRef.close([data, true]);
    this.commentService.progressSpin.emit(false)      
  }
}
